import React from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";

const mt15 = {
    marginTop: 15
}

const formatPhoneNumber = (phone) => {
    if (phone.length == 10) { 
        return `(${phone.substring(0,3)}) ${phone.substring(3,6)}-${phone.substring(6,10)}`
    } else {
        return phone
    }
}

const ReferenceCard = ({referenceType, referencia, profesionNames, parentescos}) => {
    return (
        <>
            <Card>
                <Card.Body className={'p-30'}>
                    <Row>
                    <Col xs={isBrowser ? 2 : 12}>
                            <Row>
                                <Col xs={12}>
                                    <strong> { referenceType } </strong>
                                </Col>
                            </Row>
                        </Col>
                        <Col style={!isBrowser ? mt15 : null} xs={isBrowser ? 5 : 12}>
                            <Row>
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Nombre </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    {
                                        referencia.nombre 
                                            ? referencia.nombre
                                            : 'No especificado' 
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> Apellidos </strong>
                                </Col>
                                <Col style={isBrowser ? mt15 : null} xs={isBrowser ? 9 : 12}>
                                    { 
                                        referencia.apellido 
                                            ? referencia.apellido
                                            : 'No especificado'
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> Relación </strong>
                                </Col>
                                <Col style={isBrowser ? mt15 : null} xs={isBrowser ? 9 : 12}>
                                    {   
                                        referencia.parentescoId 
                                        ? parentescos.length > 0 && parentescos.find(x => x.id == referencia.parentescoId).nombre
                                        : 'No especificado'
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col style={!isBrowser ? mt15 : null}  xs={isBrowser ? 5 : 12}>
                            <Row>
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Empresa </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    { 
                                        referencia.empresaReferencia 
                                            ? referencia.empresaReferencia
                                            : 'No especificado'
                                    }
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> Teléfono </strong>
                                </Col>
                                <Col style={isBrowser ? mt15 : null} xs={isBrowser ? 9 : 12}>
                                    { 
                                        referencia.telefono
                                            ? formatPhoneNumber(referencia.telefono) 
                                            : 'No especificado'
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <br/>
        </>
    );
};

export default ReferenceCard;